import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterUsers from '../components/MasterUsers';

const UsersPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterUsers user={user} />;
};

export default UsersPage;
